import { LoadablePaint } from '@confluence/loadable';

export const WidgetMacroHandler = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-WidgetMacro" */ '../src/WidgetMacroRenderer.tsx'))
			.WidgetMacroRenderer,
});

export type { WidgetMacroRendererProps } from '../src/WidgetMacroRenderer.tsx';
